import * as React from 'react';
import Video from './video';
import '../chiroto.css';

interface SongProps {
  title: string;
  sections: {title: string, video_id: string, date: string, section: number, orientation: string}[][];
  // link?: string;
  // title?: string;
  // technologies?: string[];
  // children?: React.ReactNode | React.ReactNode[];
}

class Song extends React.Component<SongProps> {
  render() { 
    const {title, sections} = this.props;
    return (
      <div className="session" key={title}>
        <h2>{title}</h2>
        {sections.map((section_data: any, id: any) =>  (
          <div className="grid-container" key={id}>
            <h3>Section {id + 1}</h3>
            {section_data.map((video_data: any, id: any) => {
              return (
                <Video
                  key={id}
                  title={video_data.title}
                  path={`https://drive.google.com/file/d/${video_data.video_id}/preview`}
                  orientation={video_data.orientation}
                />
              )
            })}
          </div>
        ))}




      </div>
    );
  }
}
 
export default Song;